export default __webpack_public_path__ + "static/depoimento-3-2a40d4679b49ca7079aa73c478d26368.svg";